module.exports = __webpack_public_path__ + "static/media/amusement(21).bb14f274.PNG";